export default function getIndividuals(user, dependents) {
	try {
		if (dependents?.length > 0) {
			for (const dependent of dependents) {
				dependent.name = `${dependent.firstName} ${dependent.lastName}`
				dependent.relationship = dependent.relationship?.charAt(0)?.toUpperCase() + dependent.relationship?.slice(1)
			}
		}

		return [{ id: user?.id, name: user?.firstName + " " + user?.lastName, relationship: "Self" }, ...dependents]
	} catch (error) {
		console.error(error)
		return []
	}
}
